<template>
    <div id="app">
        <router-view name="header"/>
        <div>
                <router-view/>
        </div>
        <router-view name="footer"/>
    </div>
</template>
<script>
  export default {
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'GAMS+ Monitoring',
      // all titles will be injected into this template
      titleTemplate: '%s | Electronic Technologies Corp',
      meta: [
        { charset: 'utf-8' },
      ]
    },
  }
</script>
<style>
.card-description, .description{
  font-weight: 400 !important;
}
p{
  font-weight: 400 !important;
}
@media screen and (min-width: 768px){
  .projects-5.controls-card .card-background.commercial .card-body   {
    padding-top: 250px !important;
    padding-bottom: 250px;
  }
}
.page-header.page-header-small {
    min-height: 500px;
    max-height: 500px;
}
.features-7 .info-horizontal {
    padding: 15px 0 0;
}
.info .info-title{
    margin: 23px 0 15px !important;
}
.font-color-primary{
    color: #ff5e00 !important;
}
a.font-color-primary:hover{
    border-color: transparent !important;
    text-decoration: underline !important;
}  
.bg-dark {
    background-color: #160c2b !important;
}
.nolink:hover{
    text-decoration:none;
}
.navbar-transparent .navbar-translate {
  visibility: hidden;
}
</style>
